import request from '../../src/state/modules/axios'

export function getLanguageLevelCategories(params) {
    return request({
        url: '/api/language-level-category',
        method:'get',
        params,
    })
}
